import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconQuestionMarkCircle20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconQuestionMarkCircle20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M17.5 10a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0m1.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0M8.823 6.947c-.295.263-.494.631-.597 1.03A.75.75 0 0 1 6.774 7.6c.16-.62.488-1.272 1.05-1.773C8.396 5.316 9.169 5 10.134 5c.96 0 1.774.316 2.34.954.552.623.78 1.46.78 2.345 0 1.245-.875 2.066-1.46 2.615l-.027.024-.043.041c-.31.29-.553.518-.732.755-.175.232-.24.411-.24.585a.75.75 0 1 1-1.5 0c0-.609.249-1.1.543-1.489.26-.345.594-.657.875-.92l.07-.066c.667-.624 1.015-1.025 1.015-1.545 0-.644-.167-1.082-.404-1.35-.225-.255-.596-.449-1.217-.449-.616 0-1.028.193-1.311.447m1.927 7.686a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconQuestionMarkCircle20);
